// App URL constants
export const APP_URLS = {
  BASE: process.env.REACT_APP_APPLICATION_URL || "https://www.app.doktorui.com",
  LOGIN: process.env.REACT_APP_LOGIN_PATH || "/login",
  SIGNUP: process.env.REACT_APP_SIGNUP_PATH || "/sign-up",
} as const;

// Helper functions to build complete URLs
export const getAppUrl = (path?: string) => {
  return path ? `${APP_URLS.BASE}${path}` : APP_URLS.BASE;
};

export const getLoginUrl = () => getAppUrl(APP_URLS.LOGIN);
export const getSignupUrl = () => getAppUrl(APP_URLS.SIGNUP);
